/**
 * How ProvisionTypeMatrixAgent.factor is applied: MONTHLY_PREMIUM = factor x monthly base (Mehrfache
 * Beitraege), PER_MILLE = factor/1000 x total-term base.
 *
 * Position-based mirror of the backend enum {@code com.mvs.backend.cp.enums.ProvisionMatrixCalcMode}. The backend
 * persists the ordinal (`@Enumerated(EnumType.ORDINAL)`), so the declaration order below MUST match
 * the backend exactly and new constants MUST only be appended at the end — never inserted between
 * existing ones, which would silently re-map every stored value (02-datenmodell.md §0.5/§2).
 */
export enum ProvisionMatrixCalcMode {

    MONTHLY_PREMIUM,
    PER_MILLE
}
